import ApiService from "../ApiService";
import axios from "axios";

const CheckInOrderService = {

  generateSticker(data) {
    return ApiService.post(`check-in/generate-sticker`, data);
  },

  doCheckIn(data) {
    return ApiService.post(`check-in`, data);
  },

  alreadyCheckIn(data) {
    return ApiService.post(`check-in/already-check-in`, data);
  },

  getQuantitiesFromGlobal(data) {
    return axios.post('URL_GLOBAL', data) // TODO: replace Global service URL
  },

  getQuantities(data) {
    return ApiService.post('check-in/quantities', data) // TODO: replace Global service URL
  },

  getIdOrder(data) {
    return ApiService.post('check-in/idOrder', data) // TODO: replace Global service URL
  },

  removeBarcode(data) {
    return ApiService.post('check-in/removeBarcode', data)
  },

  getQuantitiesNoInvoice(data) {
    return ApiService.post('check-in/quantities-no-invoice', data) // TODO: replace Global service URL
  }
};

export default CheckInOrderService;
